import { NavigationExtras, Router } from '@angular/router';

/**
 * This router is used to keep the embedded context when navigating with absolute urls
 * When an absolute path is provided the router adds the "/embedded" to the commands
 */
export class SoftlineEmbeddedRouter extends Router {
  override async navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    if (extras?.relativeTo) return super.navigate(commands, extras);

    if (commands.length > 0) {
      const first = commands[0];

      const firstValue = typeof first === 'string' ? first : `${first}`;

      const isRelativePath = firstValue.startsWith('..') || firstValue.startsWith('./');
      const isAbsolutePath = firstValue.startsWith('/') || !isRelativePath;

      if (isAbsolutePath && !firstValue.includes('embedded')) {
        commands = ['/embedded' + firstValue, ...commands.slice(1)];
      }
    }

    return super.navigate(commands, extras);
  }
}
